// 导入组件
import Vue from 'vue';
import Router from 'vue-router';
import Chat from '@/views/Chat.vue';
import Layout from '@/layout/index.vue';  // 导入Layout组件

// 登录
import login from "@/views/login";
import systemlogin from "@/views/systemLogin";


// 首页
import index from "@/views/index";
// 首页-新版
import home from "@/views/home";
import VueRouter from 'vue-router'

// 启用路由
Vue.use(Router);
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}
// 导出路由
export default new Router({
  mode: "history", // 去掉url中的#
  base: '/zrsystem/',
  routes: [{
      path: "/",
      name: "应用商城",
      component: () => import('@/views/marketplace/aggregate'),
      hidden: true,
      meta: {
        requireAuth: false,
      },
    },
    {
      path: "/login",
      name: "登录",
      component: login,
      hidden: true,
      meta: {
        requireAuth: false,
      },
    },
    {
      path: '/404',
      name: '404',
      component: () => import('@/views/err/404'),
      hidden: true,
      meta: {
        requireAuth: true
      }
    }, {
      path: '/401',
      name: '401',
      component: () => import('@/views/err/401'),
      hidden: true,
      meta: {
        requireAuth: true
      }
    },  {
      path: '/402',
      name: '402',
      component: () => import('@/views/err/402'),
      hidden: true,
      meta: {
        requireAuth: true
      }
    }, {
      path: '/productAll',
      name: 'productAll',
      component: () => import('@/views/marketplace/productAll'),
      hidden: true,
      meta: {
        requireAuth: true
      }
    },
     {
      path: '/aggregate',
      name: 'aggregate',
      component: () => import('@/views/marketplace/aggregate'),
      hidden: true
    },
   {
      path: '/enterprise',
      name: 'enterprise',
      component: () => import('@/views/enterprise'),
      hidden: true,
      meta: {
        requireAuth: true
      }
    },
     {
      path: '/product',
      name: 'product',
      component: () => import('@/views/marketplace/product'),
      hidden: true,
      meta: {
        requireAuth: true
      }
    }, {
      path: "/productPay",
      name: "productPay",
      component: () => import('@/views/marketplace/productPay'),

    }, {
      path: "/paySuccess",
      name: "paySuccess",
      component: () => import('@/views/marketplace/paySuccess'),
    },
    {
      path: "/productRate",
      name: "productRate",
      component: () => import('@/views/marketplace/productRate'),
      hidden: true,
      meta: {
        requireAuth: false,
      },
    },
    {
      path: "/home",
      name: "home",
      component: home,
      hidden: true,
      meta: {
        requireAuth: true
      },
      children: [{
          path: "/home/index",
          name: "data_index",
          component: () => import('@/views/data/index'),
        },
        {
          path: "/appUP/orderMG",
          name: "my-orders",
          component: () => import('@/views/order/MyOrders'),
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/account/index",
          name: "account",
          component: () => import('@/views/account/index'),

        }, {
          path: "/data/console",
          name: "console",
          component: () => import('@/views/data/console'),

        },
        // 配置管理相关路由
        {
          path: "/config/groups",
          name: "ConfigurationGroups",
          component: () => import('@/views/config/ConfigurationGroups'),
          meta: {
            requireAuth: true,
            title: '配置组管理'
          }
        },
        {
          path: "/config/settlement-info",
          name: "SettlementInfo",
          component: () => import('@/views/config/SettlementInfo'),
          meta: {
            requireAuth: true,
            title: '入驻信息'
          }
        },
        {
          path: "/config/groups/:id",
          name: "ConfigGroupDetail",
          component: () => import('@/views/config/ConfigGroupDetail'),
          meta: {
            requireAuth: true,
            title: '配置组详情'
          }
        },
        {
          path: "/config/list-items/:id/:groupId",
          name: "ListItemDetail",
          component: () => import('@/views/config/ListItemDetail'),
          meta: {
            requireAuth: true,
            title: '列表项详情'
          }
        },
        {
          path: "/auth/userAuth",
          name: "userAuth",
          component: () => import('@/views/auth/userAuth'),
          meta: {
            requireAuth: true,
            menuId: 1
          }
        }, {
          path: "/auth/qualification-certification",
          name: "qualification-certification",
          component: () => import('@/views/auth/QualificationCertification'),
          meta: {
            requireAuth: true,
            menuId: 1
          }
        }, {
          path: "/auth/certification-type",
          name: "certification-type",
          component: () => import('@/views/auth/CertificationType'),
          meta: {
            requireAuth: true,
            menuId: 4
          }
        },
        {
          path: "/auth/material-submission",
          name: "material-submission",
          component: () => import('@/views/auth/MaterialSubmission'),
          meta: {
            requireAuth: true,
            menuId: 5
          }
        }, 
        {
          path: "/auth/certification-history",
          name: "certification-history",
          component: () => import('@/views/auth/CertificationHistory'),
          meta: {
            requireAuth: true,
            menuId: 6
          }
        },
        {
          path: "/auth/draft-history",
          name: "draft-history",
          component: () => import('@/views/auth/DraftHistory'),
          meta: {
            requireAuth: true,
            menuId: 6
          }
        },
        {
          path: "/auth/certification-detail",
          name: "certification-detail",
          component: () => import('@/views/auth/CertificationDetail'),
          meta: {
            requireAuth: true,
            menuId: 7
          }
        },
        {
          path: "/bussin/certification-approval",
          name: "certification-approval",
          component: () => import('@/views/bussin/certificationApproval'),
          meta: {
            requireAuth: true,
            menuId: 12
          }
        },
        {
          path: "/bussin/certification-audit-detail",
          name: "certification-audit-detail",
          component: () => import('@/views/bussin/CertificationAuditDetail'),
          meta: {
            requireAuth: true,
            menuId: 8
          }
        },
        {
          path: "/bussin/certification-review",
          name: "certification-review",
          component: () => import('@/views/bussin/CertificationAuditDetail'),
          meta: {
            requireAuth: true,
            menuId: 8
          }
        },
        {
          path: "/auth/userHome",
          name: "userHome",
          component: () => import('@/views/auth/userHome'),

        }, {
          path: "/appUp/supplierHome",
          name: "supplierHome",
          component: () => import('@/views/appUp/supplierHome'),

        }, 
        {
          path: "/auth/widget",
          name: "Widget",
          component: () => import('@/views/auth/widget'),

        }, {
          path: '/appUp',
          name: 'appUP',
          component: () => import('@/views/appUp/index'),

        }, {
          path: '/supplierProduct',
          name: 'supplierProduct',
          component: () => import('@/views/product/supplierProduct'),

        }, {
          path: '/supplierProductEdit',
          name: 'supplierProductEdit',
          component: () => import('@/views/product/supplierProductEdit'),

        }, {
          path: '/supplierProductSetting',
          name: 'supplierProductSetting',
          component: () => import('@/views/product/supplierProductSetting'),

        },
        {
          path: '/supplierProductInfo',
          name: 'supplierProductInfo',
          component: () => import('@/views/product/supplierProductInfo'),

        }, {
          path: '/bussinessRZ',
          name: 'bussinessRZ',
          component: () => import('@/views/bussin/bussinessRZ'),

        }, {
          path: '/gysRZ',
          name: 'gysRZ',
          component: () => import('@/views/bussin/gysRZ'),

        }, {
          path: '/productSJ',
          name: 'productSJ',
          component: () => import('@/views/bussin/productSJ'),

        }, {
          path: '/productDetails1',
          name: 'productDetails1',
          component: () => import('@/views/bussin/productDetails1'),

        },
        {
          path: "/auth/userAuth0",
          name: "userAuth0",
          component: () => import('@/views/auth/userAuth0'),

        },
        {
          path: "/auth/userAuth1",
          name: "userAuth1",
          component: () => import('@/views/auth/userAuth1'),

        }, {
          path: "/application/productCollectManage",
          name: "productCollectManage",
          component: () => import('@/views/application/productCollectManage'),
        }, {
          path: "/application/appManage",
          name: "appManage",
          component: () => import('@/views/application/appManage'),
        }, {
          path: "/application/appEdit",
          component: () => import('@/views/application/appEdit'),
          name: '应用编辑',
          meta: { 
            title: '应用编辑', 
            icon: 'el-icon-edit',
            requireAuth: true
          }
        },
        {
          path: "/application/appDetail",
          component: () => import('@/views/application/appDetail'),
          name: '应用详情',
          meta: { 
            title: '应用详情', 
            icon: 'el-icon-document',
            requireAuth: true
          }
        },
        {
          path: "/sysConfig/sysApp",
          component: () => import('@/views/application/sysApp'),
          name: ' 应用上架审批',
          meta: { 
            title: '应用上架审批', 
            icon: 'el-icon-document',
            requireAuth: true
          }
        },
        {
          path: "/publicPage",
          name: "publicPage",
          component: () => import('@/views/application/publicPage'),
        }, {
          path: "/application/productRate",
          name: "productRate",
          component: () => import('@/views/application/productRate'),

        }, {
          path: "/application/index",
          name: "application",
          component: () => import('@/views/application/index'),

        }, {
          path: "/gpt/index",
          name: "gpt",
          component: () => import('@/views/gpt/index'),

        }, {
          path: "/application/frame",
          name: "frame",
          component: () => import('@/views/application/frame'),

        }, {
          path: "/application/product",
          name: "application_product",
          component: () => import('@/views/application/product'),

        },{
          path: "/chat/gpt",
          name: "chat_gpt",
          component: () => import('@/views/gpt/chat_gpt'),
        },
        {
          path: "/application/appAuditManage",
          name: "应用审核管理",
          component: () => import('@/views/application/appAuditManage'),
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/auth/messages",
          name: "task-messages",
          component: () => import('@/views/task/taskMessage'),
          meta: {
            requireAuth: true,
            menuId: 9
          }
        },
        {
          path: "/auth/tickets",
          name: "task-tickets",
          component: () => import('@/views/task/taskTickets'),
          meta: {
            requireAuth: true,
            menuId: 10
          }
        },
        {
          path: "/auth/ticket-detail/:id",
          name: "ticket-detail",
          component: () => import('@/views/task/ticketDetail'),
          meta: {
            requireAuth: true,
            menuId: 10
          }
        },
        {
          path: "/auth/taskTickets",
          name: "task-tickets",
          component: () => import('@/views/task/taskTickets'),
          meta: {
            requireAuth: true,
            menuId: 10
          }
        },
        {
          path: "/taskAdmin/messages",
          name: "TaskMessages",
          component: () => import('@/views/task/taskMessage'),
          meta: {
            requireAuth: true,
            menuId: 9
          }
        },
        {
          path: "/bussin/tickets",
          name: "admin-tickets",
          component: () => import('@/views/task/ticketAdmin'),
          meta: {
            requireAuth: true,
            menuId: 12
          }
        },
        {
          path: "/auth/ticketDetailSupplier/:id",
          name: "supplier-ticket-detail",
          component: () => import('@/views/task/ticketDetailAdmin'),
          meta: {
            requireAuth: true
          }
        },
        {
          path: "/bussin/ticketDetail/:id",
          name: "admin-ticket-detail",
          component: () => import('@/views/task/ticketDetailAdmin'),
          meta: {
            requireAuth: true,
            menuId: 13
          }
        },
        {
          path: '/bussin/invoiceAdmin',
          name: 'InvoiceAdmin',
          component: () => import('@/views/finance/invoiceAdmin'),
          meta: { title: '发票管理', menuId: 14 }
        },
        {
          path: '/bussin/ticketAdmin',
          name: 'ticketAdmin',
          component: () => import('@/views/task/ticketAdmin'),
          meta: { title: '系统工单处理',requireAuth: true }
        },
        {
          path: '/auth/ticketsSupplierPersonal',
          name: 'ticketsSupplierPersonal',
          component: () => import('@/views/task/ticketAdmin'),
          meta: { 
            title: '个人应用交付',
            mode: 'supplierPersonal',
            requireAuth: true
          }
        },
        {
          path: '/auth/ticketsSupplierCompany',
          name: 'ticketsSupplierCompany',
          component: () => import('@/views/task/ticketAdmin'),
          meta: { 
            title: '企业应用交付',
            mode: 'supplierCompany',
            requireAuth: true
          }
        },
        {
          path: '/auth/myPayment',
          name: 'MyPayment',
          component: () => import('@/views/finance/myPayment'),
          meta: { 
            title: '我的支付',
            requireAuth: true
          }
        },
        {
          path: '/auth/myInvoice',
          name: 'MyInvoice',
          component: () => import('@/views/finance/myInvoice'),
          meta: { 
            title: '发票管理',
            requireAuth: true
          }
        },
        {
          path: '/auth/myInvoiceTitle',
          name: 'MyInvoiceTitle',
          component: () => import('@/views/finance/myInvoiceTitle'),
          meta: { 
            title: '发票抬头管理',
            requireAuth: true
          }
        },
        {
          path: '/auth/createInvoice',
          name: 'CreateInvoice',
          component: () => import('@/views/finance/createInvoice'),
          meta: { 
            title: '新建发票',
            requireAuth: true
          }
        },
      ],
    },
    {
      path: '/auth',
      component: Layout,
      meta: { title: '认证管理', icon: 'el-icon-s-check', menuId: 6 },
      children: [
        {
          path: 'userAuth',
          name: 'UserAuth',
          component: () => import('@/views/auth/userAuth'),
          meta: { title: '我的认证', menuId: 7 }
        },
        {
          path: 'role-management',
          name: 'RoleManagement',
          component: () => import('@/views/auth/roleManagement'),
          meta: { title: '角色管理', menuId: 8 }
        },
        {
          path: 'dept-management',
          name: 'DeptManagement',
          component: () => import('@/views/auth/deptManagement'),
          meta: { title: '架构管理', menuId: 10 }
        },
        {
          path: 'certification-type',
          name: 'CertificationType',
          component: () => import('@/views/auth/CertificationType'),
          meta: { title: '资格认证', menuId: 8 }
        },
        {
          path: 'material-submission',
          name: 'MaterialSubmission',
          component: () => import('@/views/auth/MaterialSubmission'),
          meta: { title: '材料提交', menuId: 11 }
        },
        {
          path: 'certification-history',
          name: 'CertificationHistory',
          component: () => import('@/views/auth/CertificationHistory'),
          meta: { title: '认证历史', menuId: 12 }
        },
        {
          path: 'certification-detail',
          name: 'CertificationDetail',
          component: () => import('@/views/auth/CertificationDetail'),
          meta: { title: '认证详情', menuId: 13 },
          hidden: true
        },
        {
          path: 'certification-review',
          name: 'CertificationReview',
          component: () => import('@/views/bussin/CertificationAuditDetail'),
          meta: { title: '认证审核详情', roles: ['admin'], menuId: 14 },
          hidden: true
        }
      ]
    },
    {
      path: "/auth/callback",
      name: "AuthCallback",
      component: () => import('@/views/auth/callback'),
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/auth/messages',
      name: 'DirectTaskMessages',
      component: () => import('@/views/task/taskMessage'),
      meta: { 
        title: '消息中心',
        requireAuth: true,
        menuId: 15
      }
    },
    {
      path: '/auth/tickets',
      name: 'DirectTaskTickets',
      component: () => import('@/views/task/taskTickets'),
      meta: { 
        title: '工单中心',
        requireAuth: true,
        menuId: 16
      }
    },
    {
      path: '/auth/create-ticket',
      name: 'CreateTicket',
      component: () => import('@/views/task/createTicket'),
      meta: { 
        title: '创建工单',
        requireAuth: true,
        menuId: 17
      }
    },
    {
      path: '/auth/ticket-detail/:id',
      name: 'DirectTicketDetail',
      component: () => import('@/views/task/ticketDetail'),
      meta: { 
        title: '工单详情',
        requireAuth: true,
        menuId: 16
      }
    },
    {
      path: '/finance',
      component: Layout,
      meta: { title: '财务管理', icon: 'el-icon-money' },
      children: [
        {
          path: 'myPayment',
          name: 'FinanceMyPayment',
          component: () => import('@/views/finance/myPayment'),
          meta: { title: '我的支付', menuId: 20 }
        }
      ]
    },
    {
      path: "/certification",
      name: "open-certification",
      component: () => import('@/views/auth/QualificationCertification'),
      hidden: true,
      meta: {
        requireAuth: false,
      }
    },
    {
      path: '/register',
      name: '注册',
      component: () => import('@/views/register.vue'),
      hidden: true,
      meta: {
        requireAuth: false,
      },
    },
    {
      path: '/forgot-password',
      name: '忘记密码',
      component: () => import('@/views/forgot-password.vue'),
      hidden: true,
      meta: {
        requireAuth: false,
      },
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js